import React, { useState } from "react";
import { func, object } from "prop-types";

import "./login-modal.m.css";

export const LoginModal = ({ setActiveTab, AccountModal, selectedPlan }) => {
  const [showAccountModal, setShowAccountModal] = useState(true);

  const { plan } = selectedPlan;
  return (
    <div styleName="modal">
      <div styleName="login-modal">
        {showAccountModal && (
          <AccountModal
            isPopup={false}
            customCallbackUrl={global.location.href}
            onClose={() => {
              setShowAccountModal(false);
              setActiveTab("checkout");
            }}
          />
        )}
      </div>
    </div>
  );
};

LoginModal.propTypes = {
  setActiveTab: func,
  AccountModal: func,
  selectedPlan: object,
};
